function format(string, ...args) {
  return string.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] !== 'undefined' ? args[number] : '';
  });
}

function leadingZeroNumberFormat(number) {
  if (number < 10) {
    return '0' + number;
  } else {
    return number.toString();
  }
}

export default {
  format,
  leadingZeroNumberFormat,
};
